var GENERAL_COOL_HEAT_ZH_JT_03 = {
	name: "General ZH JT 03",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [197,0,5,76,2,53,6,82,2,235,1,70,24,188,28,88,2,150,28,104,2,0,0,63,234,170,191,234,170,191,234,170,191,234,170,187,186,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,94,2,47,6,95,2,246,1,78,24,140,28,83,2,186,28,93,2,0,0,63,234,170,191,234,170,171,254,170,182,251,106,191,117,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,80,2,50,6,82,2,230,1,85,24,177,28,92,2,166,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,175,189,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,74,2,43,6,73,2,232,1,64,24,189,28,108,2,167,28,135,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,183,187,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,87,2,48,6,68,2,236,1,40,24,182,28,95,2,164,28,111,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,171,223,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,103,2,48,6,77,2,226,1,43,24,181,28,104,2,178,28,116,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,187,186,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,96,2,49,6,72,2,238,1,54,24,169,28,96,2,157,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,222,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,104,2,35,6,80,2,230,1,80,24,167,28,108,2,175,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,181,221,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,85,2,46,6,72,2,219,1,60,24,189,28,103,2,166,28,113,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,170,239,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,85,2,41,6,98,2,213,1,91,24,175,28,98,2,158,28,130,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,189,186,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,82,2,49,6,85,2,239,1,61,24,186,28,95,2,189,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,174,222,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,97,2,36,6,81,2,228,1,95,24,173,28,106,2,161,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,182,221,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,94,2,47,6,72,2,231,1,50,24,170,28,97,2,168,28,121,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,171,111,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,103,2,45,6,67,2,233,1,42,24,148,28,107,2,182,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,186,221,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,86,2,42,6,90,2,234,1,64,24,174,28,109,2,182,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,111,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,96,2,35,6,95,2,224,1,90,24,164,28,109,2,184,28,137,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,181,110,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,79,2,43,6,81,2,230,1,56,24,183,28,105,2,175,28,131,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,170,183,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,94,2,35,6,74,2,227,1,68,24,177,28,126,2,164,28,131,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,190,186,174,173,181,182,226,16],
		},
		//////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [197,0,5,80,2,44,6,78,2,227,1,52,24,190,28,97,2,163,28,113,2,0,0,63,234,170,191,234,170,171,254,170,182,214,219,191,117,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [197,0,5,104,2,46,6,79,2,241,1,42,24,155,28,108,2,166,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,175,189,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [197,0,5,90,2,44,6,76,2,222,1,47,24,198,28,97,2,159,28,121,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,183,187,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,47,6,85,2,236,1,39,24,194,28,102,2,176,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,223,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [197,0,5,102,2,40,6,86,2,221,1,54,24,168,28,115,2,159,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,187,186,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [197,0,5,99,2,37,6,96,2,213,1,73,24,172,28,109,2,158,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,222,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [197,0,5,87,2,51,6,71,2,238,1,67,24,176,28,96,2,167,28,145,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,221,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,42,6,97,2,226,1,39,24,190,28,105,2,165,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,239,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [197,0,5,82,2,46,6,86,2,239,1,40,24,201,28,98,2,188,28,122,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,189,186,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [197,0,5,84,2,44,6,73,2,231,1,43,24,180,28,103,2,162,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,174,222,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,46,6,72,2,235,1,33,24,183,28,97,2,165,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,182,221,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [197,0,5,94,2,38,6,77,2,231,1,91,24,153,28,86,2,196,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,111,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [197,0,5,109,2,27,6,100,2,228,1,60,24,164,28,111,2,155,28,132,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,186,221,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [197,0,5,94,2,39,6,88,2,227,1,58,24,158,28,106,2,164,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,111,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [197,0,5,90,2,45,6,86,2,237,1,56,24,186,28,84,2,200,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,110,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [197,0,5,92,2,42,6,75,2,231,1,52,24,189,28,106,2,163,28,107,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,183,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [197,0,5,93,2,37,6,101,2,230,1,50,24,174,28,105,2,178,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,190,186,174,173,181,182,226,16],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [197,0,5,96,2,38,6,89,24,128,28,87,2,247,1,72,2,227,28,115,2,0,0,127,201,36,146,127,201,36,146,73,255,36,146,102,115,51,38,126,114,73,50,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,46,6,61,24,176,28,72,2,234,1,96,2,156,28,136,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,115,51,38,79,158,73,50,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,50,6,83,2,241,1,49,24,178,28,84,2,176,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,183,187,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [197,0,5,86,2,46,6,72,2,231,1,41,24,177,28,95,2,167,28,100,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,223,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [197,0,5,78,2,50,6,73,2,237,1,44,24,190,28,101,2,185,28,108,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,187,186,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [197,0,5,79,2,52,6,72,2,233,1,82,24,181,28,90,2,171,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,222,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [197,0,5,80,2,50,6,70,2,233,1,46,24,184,28,98,2,183,28,115,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,181,221,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [197,0,5,79,2,48,6,73,2,233,1,39,24,185,28,111,2,177,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,239,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [197,0,5,75,2,53,6,84,2,234,1,65,24,196,28,105,2,180,28,113,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,189,186,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [197,0,5,101,2,51,6,79,2,237,1,54,24,138,28,87,2,167,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,174,222,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [197,0,5,95,2,45,6,88,2,234,1,79,24,154,28,97,2,171,28,108,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,182,221,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [197,0,5,85,2,47,6,92,2,228,1,49,24,179,28,127,2,157,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,111,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [197,0,5,74,2,52,6,82,2,241,1,52,24,185,28,94,2,160,28,122,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,186,221,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [197,0,5,90,2,44,6,73,2,235,1,42,24,190,28,104,2,171,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,111,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [197,0,5,83,2,53,6,72,2,236,1,70,24,179,28,98,2,166,28,144,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,181,110,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [197,0,5,82,2,50,6,92,2,231,1,38,24,186,28,107,2,158,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,183,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [197,0,5,98,2,49,6,77,2,236,1,36,24,168,28,92,2,172,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,190,186,174,173,181,182,226,16],
		},
		///////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,80,2,52,6,87,2,235,1,60,24,174,28,85,2,190,28,111,2,0,0,63,234,170,191,234,170,171,254,170,182,221,182,191,117,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,92,2,46,6,74,2,239,1,63,24,186,28,130,2,165,28,107,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,175,189,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,98,2,45,6,72,2,232,1,57,24,173,28,96,2,160,28,122,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,183,187,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,102,2,28,6,103,2,212,1,96,24,147,28,117,2,127,28,144,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,223,86,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,85,2,41,6,85,2,234,1,66,24,179,28,91,2,186,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,187,186,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,78,2,47,6,77,2,237,1,66,24,182,28,103,2,173,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,222,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,96,2,42,6,71,2,235,1,62,24,171,28,126,2,152,28,118,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,221,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,84,2,48,6,69,2,235,1,50,24,170,28,92,2,206,28,116,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,170,239,214,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,36,6,89,2,230,1,47,24,175,28,100,2,173,28,116,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,189,186,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,92,2,36,6,87,2,233,1,54,24,197,28,102,2,144,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,174,222,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,100,2,32,6,91,2,231,1,38,24,192,28,111,2,175,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,182,221,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,104,2,36,6,79,2,225,1,82,24,128,28,106,2,200,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,111,182,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,100,2,46,6,72,2,236,1,54,24,177,28,93,2,176,28,131,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,186,221,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,91,2,39,6,75,2,228,1,66,24,168,28,106,2,155,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,111,118,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,93,2,39,6,72,2,229,1,84,24,172,28,96,2,166,28,131,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,110,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,83,2,41,6,96,2,225,1,55,24,173,28,96,2,203,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,170,183,246,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,44,6,87,2,239,1,32,24,183,28,123,2,142,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,190,186,174,173,181,182,226,16],
		},
		////////////////////////HEAT/////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,73,2,47,6,59,24,174,28,90,2,221,1,119,2,148,28,122,2,0,0,127,201,36,146,127,201,36,146,73,255,36,146,102,124,204,146,127,146,73,36,204,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,88,2,39,6,47,24,175,28,98,2,228,1,98,2,141,28,113,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,79,230,73,36,204,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,81,2,38,6,71,2,227,1,46,24,180,28,110,2,170,28,122,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,183,235,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,104,2,41,6,72,2,231,1,56,24,150,28,134,2,138,28,132,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,171,247,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,102,2,34,6,72,2,232,1,66,24,178,28,107,2,168,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,187,234,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,94,2,35,6,72,2,231,1,53,24,178,28,110,2,167,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,246,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,102,2,27,6,85,2,234,1,58,24,151,28,112,2,173,28,129,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,181,245,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,93,2,36,6,85,2,222,1,58,24,177,28,104,2,141,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,170,251,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,79,2,42,6,72,2,230,1,67,24,175,28,130,2,138,28,132,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,189,234,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,84,2,37,6,72,2,238,1,39,24,166,28,129,2,150,28,118,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,174,246,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,90,2,38,6,72,2,230,1,72,24,175,28,100,2,174,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,182,245,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,84,2,42,6,72,2,233,1,80,24,156,28,95,2,158,28,104,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,171,123,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,96,2,34,6,82,2,224,1,47,24,180,28,133,2,150,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,186,245,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,79,2,41,6,91,2,233,1,66,24,178,28,98,2,185,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,123,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,82,2,44,6,72,2,239,1,71,24,157,28,94,2,178,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,181,122,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,108,2,31,6,99,2,215,1,48,24,156,28,102,2,174,28,98,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,170,189,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,95,2,35,6,71,2,230,1,51,24,160,28,95,2,163,28,138,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,190,234,173,109,181,182,226,16],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [197,0,5,84,2,40,6,72,2,234,1,57,24,178,28,108,2,146,28,122,2,0,0,63,234,170,191,234,170,171,254,170,182,214,219,191,213,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [197,0,5,85,2,50,6,82,2,235,1,68,24,166,28,89,2,189,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,175,237,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [197,0,5,91,2,37,6,86,2,245,1,33,24,172,28,88,2,172,28,109,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,183,235,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [197,0,5,93,2,45,6,90,2,228,1,54,24,187,28,93,2,166,28,91,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,247,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [197,0,5,85,2,44,6,84,2,251,1,58,24,176,28,87,2,189,28,105,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,187,234,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [197,0,5,79,2,45,6,72,2,234,1,41,24,183,28,121,2,156,28,129,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,246,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,52,6,81,2,236,1,40,24,174,28,81,2,173,28,108,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,245,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [197,0,5,91,2,42,6,79,2,241,1,31,24,180,28,108,2,155,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,251,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [197,0,5,85,2,47,6,72,2,235,1,54,24,174,28,95,2,156,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,189,234,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,49,6,78,2,223,1,29,24,180,28,72,2,178,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,174,246,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [197,0,5,82,2,43,6,71,2,225,1,44,24,180,28,94,2,157,28,118,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,182,245,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [197,0,5,84,2,45,6,73,2,233,1,33,24,172,28,97,2,147,28,128,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,123,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [197,0,5,96,2,40,6,93,2,232,1,34,24,176,28,101,2,156,28,105,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,186,245,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [197,0,5,95,2,41,6,73,2,234,1,43,24,172,28,96,2,165,28,96,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,123,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [197,0,5,80,2,47,6,66,2,239,1,40,24,178,28,94,2,160,28,146,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,122,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,50,6,71,2,235,1,45,24,175,28,92,2,194,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,189,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [197,0,5,95,2,44,6,85,2,239,1,44,24,173,28,94,2,163,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,190,234,173,109,181,182,226,16],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [197,0,5,82,2,43,6,72,2,254,1,58,24,186,28,74,2,185,28,89,2,0,0,63,234,170,191,234,170,171,254,170,182,237,181,191,213,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [197,0,5,78,2,49,6,79,2,235,1,39,24,183,28,96,2,158,28,113,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,175,237,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [197,0,5,93,2,45,6,80,2,233,1,40,24,172,28,94,2,162,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,183,235,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [197,0,5,85,2,48,6,70,2,233,1,49,24,169,28,94,2,164,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,247,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,41,6,72,2,236,1,30,24,175,28,96,2,161,28,115,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,187,234,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,47,6,74,2,236,1,39,24,173,28,81,2,172,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,246,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [197,0,5,89,2,42,6,72,2,232,1,54,24,164,28,118,2,154,28,103,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,181,245,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [197,0,5,91,2,21,6,80,2,246,1,38,24,152,28,73,2,184,28,107,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,251,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [197,0,5,77,2,49,6,79,2,241,1,44,24,186,28,97,2,153,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,189,234,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [197,0,5,87,2,40,6,90,2,235,1,53,24,167,28,110,2,152,28,129,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,174,246,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [197,0,5,81,2,44,6,72,2,236,1,21,24,183,28,102,2,160,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,182,245,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [197,0,5,103,2,45,6,83,2,239,1,34,24,158,28,98,2,151,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,123,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [197,0,5,98,2,53,6,83,2,244,1,47,24,155,28,91,2,165,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,186,245,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [197,0,5,83,2,46,6,72,2,235,1,38,24,180,28,101,2,165,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,123,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [197,0,5,82,2,40,6,91,2,230,1,48,24,178,28,110,2,156,28,121,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,181,122,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [197,0,5,96,2,35,6,73,2,230,1,47,24,190,28,107,2,162,28,121,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,189,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [197,0,5,98,2,24,6,77,2,234,1,29,24,165,28,89,2,168,28,138,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,190,234,173,109,181,182,226,16],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,87,2,41,6,92,2,253,1,38,24,182,28,97,2,164,28,130,2,0,0,63,234,170,191,234,170,171,254,170,182,221,182,191,213,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,84,2,47,6,94,2,227,1,58,24,182,28,104,2,162,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,175,237,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,87,2,41,6,72,2,252,1,84,24,136,28,91,2,173,28,102,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,183,235,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,87,2,44,6,92,2,249,1,46,24,178,28,90,2,167,28,116,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,247,85,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,96,2,40,6,83,2,224,1,39,24,188,28,104,2,179,28,135,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,187,234,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,78,2,52,6,73,2,238,1,58,24,183,28,105,2,151,28,134,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,246,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,80,2,45,6,71,2,237,1,39,24,184,28,105,2,151,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,245,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,44,6,72,2,237,1,36,24,182,28,94,2,163,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,170,251,213,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,79,2,49,6,90,2,234,1,41,24,180,28,96,2,163,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,189,234,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,83,2,42,6,91,2,234,1,56,24,174,28,108,2,161,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,174,246,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,79,2,51,6,79,2,239,1,32,24,190,28,91,2,162,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,182,245,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,81,2,48,6,72,2,236,1,35,24,179,28,94,2,155,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,123,181,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,90,2,52,6,72,2,239,1,41,24,170,28,90,2,172,28,109,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,186,245,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,45,6,90,2,238,1,39,24,179,28,93,2,160,28,119,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,123,117,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,87,2,36,6,76,2,238,1,44,24,175,28,73,2,186,28,99,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,122,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,78,2,48,6,77,2,235,1,37,24,188,28,98,2,171,28,113,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,170,189,245,109,181,182,226,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,111,2,35,6,86,2,234,1,60,24,131,28,96,2,179,28,90,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,190,234,173,109,181,182,226,16],
		},
		///////////////////////////AUTO//////////////////////////////
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,85,2,41,6,85,2,240,1,47,24,174,28,102,2,159,28,119,2,0,0,63,234,170,191,234,170,171,254,170,182,251,106,174,253,106,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [197,0,5,88,2,36,6,78,2,255,1,13,24,177,28,94,2,173,28,123,2,0,0,63,234,170,191,234,170,173,253,170,182,214,219,174,253,106,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [197,0,5,82,2,41,6,83,2,246,1,67,24,157,28,71,2,186,28,90,2,0,0,63,234,170,191,234,170,173,253,170,182,237,181,174,253,106,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,42,6,84,2,6,2,31,24,185,28,73,2,210,28,90,2,0,0,63,234,170,191,234,170,173,253,170,182,221,182,174,253,106,173,181,182,226,16],
		},
		////////////////////////////DRY////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [197,0,5,101,2,47,6,85,2,234,1,25,24,174,28,110,2,168,28,116,2,0,0,63,234,170,191,234,170,175,250,170,182,214,219,174,238,181,173,181,182,226,16],
		},
		/////////////////////////////FAN///////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,74,2,46,6,50,24,187,28,71,2,231,1,111,2,155,28,130,2,0,0,127,201,36,146,127,201,36,146,73,255,36,146,102,124,204,146,126,76,146,78,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,81,2,51,6,73,2,225,1,38,24,177,28,119,2,162,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,175,174,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,81,2,45,6,70,2,228,1,51,24,173,28,102,2,153,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,183,173,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,93,2,43,6,37,24,162,28,87,2,236,1,98,2,156,28,119,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,73,228,242,78,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,85,2,45,6,92,2,234,1,46,24,173,28,110,2,178,28,114,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,187,173,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,80,2,44,6,90,2,234,1,42,24,179,28,102,2,157,28,131,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,215,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,88,2,39,6,57,24,155,28,94,2,229,1,104,2,158,28,114,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,100,228,206,78,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,96,2,42,6,91,2,233,1,35,24,174,28,107,2,149,28,132,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,170,235,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,91,2,46,6,92,2,233,1,43,24,178,28,103,2,171,28,125,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,189,173,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,95,2,42,6,66,24,167,28,72,2,231,1,108,2,179,28,115,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,78,100,228,206,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,103,2,44,6,84,2,237,1,23,24,177,28,96,2,161,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,182,214,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,87,2,42,6,72,2,234,1,63,24,176,28,102,2,151,28,135,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,171,107,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,82,2,39,6,39,24,178,28,72,2,229,1,113,2,154,28,114,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,114,100,201,206,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,82,2,44,6,72,2,234,1,44,24,179,28,104,2,160,28,135,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,173,107,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,89,2,42,6,94,2,231,1,28,24,190,28,129,2,147,28,123,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,181,107,123,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,84,2,47,6,31,24,180,28,80,2,237,1,100,2,190,28,115,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,124,204,146,73,38,79,206,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [197,0,5,77,2,51,6,80,2,239,1,57,24,182,28,89,2,164,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,251,106,190,173,87,173,181,182,226,16],
		},
		///////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [197,0,5,78,2,50,6,89,2,233,1,38,24,184,28,89,2,156,28,117,2,0,0,63,234,170,191,234,170,171,254,170,182,214,219,191,90,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [197,0,5,90,2,37,6,82,2,229,1,58,24,184,28,113,2,200,28,134,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,175,174,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [197,0,5,76,2,45,6,85,2,236,1,39,24,180,28,110,2,208,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,183,173,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,44,6,90,2,231,1,52,24,166,28,103,2,167,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,215,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,50,6,80,2,236,1,40,24,176,28,84,2,174,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,187,173,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [197,0,5,95,2,48,6,91,2,225,1,57,24,156,28,94,2,189,28,121,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,215,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [197,0,5,99,2,22,6,84,2,243,1,25,24,179,28,90,2,169,28,109,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,214,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,44,6,87,2,250,1,34,24,187,28,73,2,190,28,82,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,235,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [197,0,5,84,2,43,6,73,2,0,2,77,24,140,28,110,2,172,28,96,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,189,173,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [197,0,5,86,2,38,6,86,2,242,1,31,24,191,28,76,2,170,28,111,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,174,215,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,51,6,69,2,236,1,40,24,181,28,81,2,174,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,182,214,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [197,0,5,93,2,41,6,72,2,232,1,10,24,184,28,111,2,171,28,93,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,171,107,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [197,0,5,83,2,49,6,83,2,237,1,34,24,181,28,92,2,162,28,118,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,186,214,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [197,0,5,85,2,37,6,80,2,250,1,43,24,175,28,74,2,187,28,101,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,173,107,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [197,0,5,89,2,45,6,78,2,247,1,43,24,177,28,97,2,160,28,140,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,181,107,123,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [197,0,5,81,2,27,6,90,2,0,2,31,24,178,28,82,2,183,28,100,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,170,181,251,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [197,0,5,99,2,42,6,82,2,245,1,64,24,151,28,97,2,180,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,214,219,190,173,87,173,181,182,226,16],
		},
		/////////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [197,0,5,104,2,40,6,73,2,239,1,36,24,160,28,113,2,170,28,118,2,0,0,63,234,170,191,234,170,171,254,170,182,237,181,191,90,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [197,0,5,95,2,22,6,81,2,250,1,36,24,183,28,83,2,168,28,104,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,175,174,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [197,0,5,86,2,39,6,75,2,1,2,39,24,170,28,76,2,211,28,91,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,183,173,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [197,0,5,98,2,17,6,80,2,1,2,71,24,180,28,70,2,186,28,96,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,215,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [197,0,5,99,2,40,6,72,2,224,1,16,24,174,28,91,2,163,28,117,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,187,173,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [197,0,5,84,2,51,6,91,2,214,1,38,24,183,28,91,2,162,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,215,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [197,0,5,90,2,50,6,72,2,237,1,20,24,180,28,93,2,161,28,132,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,181,214,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [197,0,5,89,2,43,6,78,2,230,1,58,24,166,28,109,2,153,28,127,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,235,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [197,0,5,81,2,49,6,85,2,245,1,27,24,186,28,89,2,167,28,98,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,189,173,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [197,0,5,83,2,51,6,84,2,239,1,66,24,185,28,103,2,178,28,109,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,174,215,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,45,6,83,2,239,1,48,24,175,28,81,2,174,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,182,214,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [197,0,5,102,2,22,6,92,2,238,1,41,24,145,28,97,2,175,28,110,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,171,107,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [197,0,5,84,2,42,6,76,2,238,1,40,24,177,28,96,2,154,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,186,214,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [197,0,5,81,2,48,6,78,2,239,1,20,24,186,28,77,2,185,28,109,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,173,107,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [197,0,5,88,2,40,6,44,24,179,28,76,2,233,1,96,2,162,28,126,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,115,51,38,100,153,51,206,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [197,0,5,95,2,50,6,85,2,240,1,40,24,155,28,91,2,171,28,115,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,170,181,251,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [197,0,5,87,2,39,6,73,2,227,1,34,24,183,28,115,2,156,28,124,2,0,0,63,234,170,191,234,170,183,246,170,182,237,181,190,173,87,173,181,182,226,16],
		},
		////////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,90,2,43,6,78,2,232,1,39,24,184,28,116,2,150,28,108,2,0,0,63,234,170,191,234,170,171,254,170,182,221,182,191,90,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,93,2,41,6,77,2,236,1,39,24,174,28,92,2,168,28,108,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,175,174,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,91,2,44,6,72,2,235,1,50,24,169,28,93,2,157,28,120,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,183,173,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,90,2,46,6,83,2,238,1,42,24,182,28,106,2,166,28,122,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,215,171,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,86,2,42,6,91,2,247,1,34,24,186,28,72,2,183,28,92,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,187,173,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,80,2,50,6,92,2,235,1,42,24,175,28,127,2,135,28,135,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,215,107,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,92,2,34,6,84,2,229,1,56,24,163,28,117,2,150,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,214,235,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,77,2,47,6,56,24,170,28,72,2,225,1,97,2,150,28,124,2,0,0,127,201,36,146,127,201,36,146,103,243,36,146,102,103,51,50,73,57,62,78,76,204,153,153,196,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,94,2,41,6,72,2,233,1,55,24,162,28,105,2,181,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,189,173,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,92,2,24,6,81,2,255,1,40,24,174,28,72,2,195,28,95,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,174,215,91,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,96,2,37,6,76,2,228,1,56,24,159,28,103,2,148,28,126,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,182,214,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,85,2,47,6,73,2,252,1,36,24,176,28,82,2,162,28,102,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,171,107,219,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,91,2,28,6,83,2,255,1,85,24,128,28,92,2,186,28,93,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,186,214,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,85,2,40,6,88,2,249,1,34,24,188,28,72,2,178,28,94,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,173,107,187,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,87,2,36,6,91,2,252,1,63,24,172,28,123,2,160,28,100,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,181,107,123,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,82,2,45,6,78,2,221,1,46,24,185,28,75,2,177,28,112,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,170,181,251,173,181,182,226,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [197,0,5,85,2,38,6,75,2,252,1,85,24,131,28,74,2,184,28,89,2,0,0,63,234,170,191,234,170,183,246,170,182,221,182,190,173,87,173,181,182,226,16],
		},
	]
}

export default GENERAL_COOL_HEAT_ZH_JT_03
